import { get } from './client.js'

export function listTools() {
  return get('/tools')
}
